import { useState } from 'react';
import { useAbort } from '../../../../../utils/commonFunctions';
import { useAppDispatch } from '../../../../../app/redux/hooks';

export const GeofenceSliderIcons = [
  {
    name: 'menu',
    icon: 'iconamoon:menu-burger-horizontal-bold',
    width: '24',
    height: '24',
    color: '#000'
  },
  {
    name: 'Add',
    icon: 'icon-park-solid:add',
    width: '24',
    height: '24'
  }
];

export const menuIcon = GeofenceSliderIcons?.find((item: any) => item?.name === 'menu');
export const addIcon = GeofenceSliderIcons?.find((item: any) => item?.name === 'Add');

export const useGeofenceStates = () => {
  const [row, setRow] = useState<any>();
  const [filteredRow, setFilteredRow] = useState<any>();
  const [isOpen, setIsOpen] = useState<any>('');
  const [cardData, setCardData] = useState<any>();
  const [isCircular, setIsCircular] = useState<boolean>(true);
  const [expanded, setExpanded] = useState<boolean>(true);
  const [cardOpen, setCardOpen] = useState<any>(false);

  const dispatch = useAppDispatch();
  const createAbort = useAbort();

  return {
    row,
    setRow,
    filteredRow,
    setFilteredRow,
    isOpen,
    setIsOpen,
    setCardData,
    cardData,
    setIsCircular,
    isCircular,
    setExpanded,
    expanded,
    dispatch,
    createAbort,
    setCardOpen,
    cardOpen
  };
};
